//images
import en from "./../assets/images/flags/gb.svg";
import r from "./../assets/images/flags/r.svg";
import ua from "./../assets/images/flags/ua.svg";
import es from "./../assets/images/flags/es.svg";
import kr from "./../assets/images/flags/kr.svg";
import tr from "./../assets/images/flags/tr.svg";
import fr from "./../assets/images/flags/fr.svg";
import el from "./../assets/images/flags/gr.svg";
import th from "./../assets/images/flags/th.svg";
import vn from "./../assets/images/flags/vn.svg";
import id from "./../assets/images/flags/id.svg";
import cn from "./../assets/images/flags/cn.svg";
import pt from "./../assets/images/flags/pt.svg";
import eg from "./../assets/images/flags/eg.svg";
import de from "./../assets/images/flags/de.svg";
import it from "./../assets/images/flags/it.svg";
import ind from "./../assets/images/flags/in.svg";
import il from "./../assets/images/flags/il.svg";
import jp from "./../assets/images/flags/jp.svg";
import ph from "./../assets/images/flags/ph.svg";

import { config } from '../config';

export interface ILanguageItem {
  lang: string;
  label: string;
  code: string;
  flag: any;
};

export const REACT_APP_LANGUAGES: string = config.languages || "[]";
export const availableBrandLanguages = JSON.parse(REACT_APP_LANGUAGES);

export const RTL_LANGUAGES = ['ar', 'he'];

const languages: ILanguageItem[] = [
  {
    lang: 'en',
    label: 'English',
    code: 'en_US',
    flag: en,
  },
  {
    lang: 'uk',
    label: 'Українська',
    code: 'uk_UA',
    flag: ua,
  },
  {
    lang: 'ru',
    label: 'Русский',
    code: 'ru_RU',
    flag: r,
  },
  {
    lang: 'es',
    label: 'Español',
    code: 'es_ES',
    flag: es,
  },
  {
    lang: 'ko',
    label: '한국어',
    code: 'ko_KR',
    flag: kr,
  },
  {
    lang: 'tr',
    label: 'Türkçe',
    code: 'tr_TR',
    flag: tr,
  },
  {
    lang: 'el',
    label: 'Ελληνικά',
    code: 'el_GR',
    flag: el,
  },
  {
    lang: 'fr',
    label: 'Français',
    code: 'fr_FR',
    flag: fr,
  },
  {
    lang: 'th',
    label: 'ไทย',
    code: 'th_TH',
    flag: th,
  },
  {
    lang: 'vi',
    label: 'Tiếng Việt',
    code: 'vi_VN',
    flag: vn,
  },
  {
    lang: 'id',
    label: 'Bahasa Indonesia',
    code: 'id_ID',
    flag: id,
  },
  {
    lang: 'zh',
    label: '中文（简体)',
    code: 'zh_CN',
    flag: cn,
  },
  {
    lang: 'pt',
    label: 'Português',
    code: 'pt_PT',
    flag: pt,
  },
  {
    lang: 'ar',
    label: 'العربية',
    code: 'ar_EG',
    flag: eg,
  },
  {
    lang: 'de',
    label: 'Deutsch',
    code: 'de_DE',
    flag: de,
  },
  {
    lang: 'it',
    label: 'Italiano',
    code: 'it_IT',
    flag: it,
  },
  {
    lang: 'hi',
    label: 'हिन्दी',
    code: 'hi_IN',
    flag: ind,
  },
  {
    lang: 'he',
    label: 'עברית',
    code: 'he_IL',
    flag: il,
  },
  {
    lang: 'ja',
    label: '日本語',
    code: 'ja_JP',
    flag: jp,
  },
  {
    lang: 'fil',
    label: 'Filipino',
    code: 'fil_PH',
    flag: ph,
  }
];
export default languages

export const availableLanguages = languages.reduce((acc: ILanguageItem[], item: ILanguageItem) => {
  if (availableBrandLanguages.includes(item.lang)) {
    acc.push(item);
  }
  return acc;
}, []);
